import { Button } from '../button/button';
import { Heading } from '../heading/heading';
import { Text } from '../text/text';
import { Modal } from '../modal/modal';
import { useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { cviSemantic } from '../../style/theme';


type CookieModalProps = {
    close: () => void;
    setFirstTabbableElement: (el?: any) => void;
    setLastTabbableElement: (el?: any) => void;
    closeButtonRef?: any;
};

export const CookieModal = (props: CookieModalProps) => {
    const { localize } = useContext(AppContext);

    const acceptCookie = () => {
        props.close();
        window.Cookiebot.renew(); // Trigger Cookiebot's consent pop-up
    };
    
    return (
        <Modal
            visible={true}
            onClose={() => props.close()}
            size='normal'
            darkenBackground={true}
            closeButtonRef={(el: HTMLElement) => props.setFirstTabbableElement(el)}
        >
            <div class="flex flex-col items-start gap-cvi-6 text-left">
                <Heading tag="h3" variant="heading-xl" noBlockSpacing>{localize('external-media-cookie-warning-header', 'Cookie information')}</Heading>
                <Text fontSize="body-md" color={cviSemantic.fgMuted} noBlockSpacing>{localize('external-media-cookie-warning-text', 'This media is from an external source that requires marketing cookies. To play the media, please enable marketing cookies in the upcoming popup.')}</Text>

                <div class="flex justify-start gap-cvi-6 max-tablet-original:w-full max-tablet-original:gap-cvi-5">
                    <Button class="max-tablet-original:w-full" variant="primary" label={localize('continue', 'Continue')} onClick={acceptCookie} />
                    <Button class="max-tablet-original:w-full" variant="secondary" label={localize('cancel', 'Cancel')} onClick={() => props.close()} element={(el: HTMLElement) => props.setLastTabbableElement(el)} />
                </div>
            </div>
        </Modal>
    );
};

